import { Pipe, PipeTransform } from '@angular/core'

/**
 * Maps a goal number (GoalId) to its one-pager file name.
 * Mirrors getGoalFileName() from GoalDetailsComponent.
 *
 * Usage:
 *   {{ goal.goalNumber | goalFileName }}
 */
@Pipe({ name: 'goalFileName', standalone: false })
export class GoalFileNamePipe implements PipeTransform {
   transform(goalNumber: string | number | null | undefined): string {
      if (goalNumber == null) return 'One Pager'
      const id = typeof goalNumber === 'number' ? goalNumber : parseInt(goalNumber, 10)
      if (isNaN(id)) return 'One Pager'
      switch (id) {
         case 1:
            return 'In-House Revenue One Pager'
         case 2:
            return 'Service Visits per DVM Day One Pager'
         case 3:
            return 'Home Delivery Client Penetration One Pager'
         case 4:
            return 'DVM Caseload One Pager'
         case 5:
            return 'Net Promoter Score One Pager'
         case 6:
            return 'Material Ordering One Pager'
         case 7:
            return 'Support Staff Payroll One Pager'
         case 8:
            return 'Continuous Care One Pager'
         case 9:
            return 'Checkout Links One Pager'
         case 11:
            return 'Preventatives One Pager'
         case 13:
            return 'Insurance & Financing One Pager'
         case 16:
            return 'GROW Session Call Answer Rates'
         default:
            return 'One Pager'
      }
   }
}
